// hospitality.js

const hospitality = {
  id: 15,
  title: "Hospitality Management",
  questions: [
    {
      question: "Do you manage guest hospitality?",
      answer:
        "Yes, we provide complete hospitality management including guest handling and accommodation.",
    },
    {
      question: "Can airport pickups and transfers be arranged?",
      answer:
        "Yes, airport transfers and transportation logistics are fully managed.",
    },
    {
      question: "Do you provide VIP hospitality services?",
      answer:
        "Yes, premium and VIP guest hospitality solutions are available for special events.",
    },
  ],
};

export default hospitality;